import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import client from '../../api';
import TableSiberat from '../../components/table/TableSiberat';

const formatMoneyText = value => {
  const num = parseInt(value ?? 0);
  return `Rp ${Number.isFinite(num) ? num.toLocaleString('id-ID') : '0'}`;
};

const DetailInvoice = ({ detailInvoice, onClose }) => {
  const { user } = useSelector(state => state.auth);
  const [lineItems, setLineItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const getInvoiceDetail = async () => {
      if (!detailInvoice?.id) {
        setLineItems([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await client.get(
          `/api/customers/invoice/${detailInvoice.id}`,
          {
            headers: {
              'Content-type': 'application/json',
              Authorization: `Bearer ${user.data.token}`
            }
          }
        );
        if (!active) return;
        setLineItems(Array.isArray(response.data) ? response.data : []);
      } catch {
        if (active) setLineItems([]);
      } finally {
        if (active) setLoading(false);
      }
    };

    getInvoiceDetail();
    return () => {
      active = false;
    };
  }, [detailInvoice?.id, user?.data?.token]);

  const infoItems = useMemo(
    () => [
      {
        label: 'Tanggal Invoice',
        value: detailInvoice?.inv_tgl
          ? moment(detailInvoice.inv_tgl).format('DD MMM YYYY')
          : '-'
      },
      {
        label: 'Jatuh Tempo',
        value: detailInvoice?.inv_due
          ? moment(detailInvoice.inv_due).format('DD MMM YYYY')
          : '-'
      },
      {
        label: 'AR Overdue',
        value:
          detailInvoice?.ar_overdue === 'Done'
            ? 'Done'
            : detailInvoice?.ar_overdue
            ? `${detailInvoice.ar_overdue} Hari`
            : '-'
      }
    ],
    [detailInvoice]
  );

  const moneyItems = useMemo(
    () => [
      {
        label: 'Sub Total',
        value: formatMoneyText(detailInvoice?.total_inv)
      },
      {
        label: 'PPN',
        value: formatMoneyText(detailInvoice?.total_tax)
      },
      {
        label: 'Asuransi',
        value: formatMoneyText(detailInvoice?.tot_ins)
      },
      {
        label: 'Total Invoice',
        value: formatMoneyText(detailInvoice?.total_invtax),
        emphasize: true
      }
    ],
    [detailInvoice]
  );

  const columns = useMemo(
    () => [
      { label: 'No', field: 'no', width: '6%', verticalAlign: 'middle' },
      {
        label: 'Tanggal',
        field: 'date',
        width: '14%',
        verticalAlign: 'middle'
      },
      {
        label: 'Deskripsi',
        field: 'desc',
        width: '42%',
        verticalAlign: 'middle'
      },
      {
        label: 'Harga',
        field: 'price',
        width: '20%',
        align: 'right',
        verticalAlign: 'middle'
      },
      {
        label: 'No. SO',
        field: 'so',
        width: '18%',
        verticalAlign: 'middle'
      }
    ],
    []
  );

  const rows = useMemo(
    () =>
      lineItems.map((item, index) => ({
        id: parseInt(item?.id) || index,
        no: <span className='order-cell__date'>{index + 1}.</span>,
        date: (
          <span className='invoice-due-date'>
            {item?.tgl_order
              ? moment(item.tgl_order).format('DD MMM YYYY')
              : '-'}
          </span>
        ),
        desc: (
          <span className='invoice-detail__desc'>
            {item?.inv_desc || '-'}
          </span>
        ),
        price: (
          <span className='order-price'>
            {formatMoneyText(item?.inv_harga)}
          </span>
        ),
        so: (
          <span className='order-cell__date'>
            {item?.so_number || item?.po_number || '-'}
          </span>
        )
      })),
    [lineItems]
  );

  return (
    <div className='invoice-detail'>
      <div className='invoice-detail__meta invoice-detail__meta--info'>
        {infoItems.map(item => (
          <div key={item.label} className='invoice-detail__meta-item'>
            <span className='invoice-detail__meta-label'>{item.label}</span>
            <span className='invoice-detail__meta-value'>{item.value}</span>
          </div>
        ))}
      </div>

      <div className='invoice-detail__meta invoice-detail__meta--money'>
        {moneyItems.map(item => (
          <div
            key={item.label}
            className={`invoice-detail__meta-item${
              item.emphasize ? ' is-emphasize' : ''
            }`}>
            <span className='invoice-detail__meta-label'>{item.label}</span>
            <span className='invoice-detail__meta-value'>{item.value}</span>
          </div>
        ))}
      </div>

      <div className='invoice-detail__table'>
        <TableSiberat
          columns={columns}
          rows={rows}
          loading={loading}
          emptyMessage='Rincian invoice belum tersedia'
          hidePageSize
        />
      </div>

      <div className='invoice-detail__actions'>
        <button type='button' className='sb-btn sb-btn--neutral' onClick={onClose}>
          Tutup
        </button>
      </div>
    </div>
  );
};

export default DetailInvoice;
